export const mapModeIncludesAll = (mapModes, validModes) => {
    return validModes.every(mode => mapModes.includes(mode));
};

export const mapModeIsValid = (mapModes, possibleValidModes = []) => {
    return possibleValidModes.some(validModes => {
        return mapModes.length === validModes.length && mapModes.every(mode => validModes.includes(mode));
    });
};

export default mapModeIsValid;
